import { nextTick, onMounted, onUnmounted } from 'vue';

const BACKGROUND_SELECTOR = '.b-announcement__site-background';

/**
 * Provides offset management for the Announcement block.
 *
 * @param contentRef
 * @returns {{updateAnnouncementBackgroundOffset: updateAnnouncementBackgroundOffset}}
 */
export function useAnnouncementBackgroundOffset(contentRef) {
  function updateAnnouncementBackgroundOffset() {
    const contentContainer = document.querySelector('#content-container');
    const userBar = document.querySelector('#user-bar');
    const backgroundRoot = contentRef.value ?? document;
    const backgrounds = backgroundRoot.querySelectorAll(BACKGROUND_SELECTOR);

    if (!contentContainer || !userBar || backgrounds.length === 0) return;

    const containerTop = contentContainer.getBoundingClientRect().top;
    const userBarBottom = userBar.getBoundingClientRect().bottom;
    const backgroundTop = Math.max(0, userBarBottom - containerTop);

    backgrounds.forEach(background => {
      background.style.top = `${backgroundTop}px`;
    });
  }

  function updateAnnouncementBackgroundOffsetAfterRender() {
    nextTick(() => {
      updateAnnouncementBackgroundOffset();
    });
  }

  onMounted(() => {
    updateAnnouncementBackgroundOffsetAfterRender();
    window.addEventListener('resize', updateAnnouncementBackgroundOffset);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateAnnouncementBackgroundOffset);
  });

  return {
    updateAnnouncementBackgroundOffset,
  };
}
